import { api } from "@/lib/apiClient";

const VID_KEY = "apx_visitor_id";
const UTM_KEY = "apx_utm";

function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) {
    v = `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(VID_KEY, v);
  }
  return v;
}

// Capture UTM params on landing and remember them for the session (first-touch attribution)
function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const incoming = {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
  };
  if (incoming.utm_source || incoming.utm_medium || incoming.utm_campaign) {
    sessionStorage.setItem(UTM_KEY, JSON.stringify(incoming));
    return incoming;
  }
  try { return JSON.parse(sessionStorage.getItem(UTM_KEY)) || {}; } catch { return {}; }
}

export function trackEvent(event, meta = {}) {
  const utm = captureUtm();
  const payload = {
    event,
    visitor_id: getVisitorId(),
    path: window.location.pathname,
    referrer: document.referrer || "",
    ...utm,
    meta,
  };
  // Fire-and-forget; never block the UI
  api.post("/track", payload).catch(() => {});
}

let _inited = false;
export function initTracking() {
  if (_inited) return;
  _inited = true;
  captureUtm();
  claimReferral();
  // Record one visit per session
  if (!sessionStorage.getItem("apx_visit_logged")) {
    sessionStorage.setItem("apx_visit_logged", "1");
    trackEvent("visit");
  }
}

// ---- Referrals ("Each One, Reach One") ----
export function getReferralLink() {
  const code = getVisitorId();
  return `${window.location.origin}/?ref=${encodeURIComponent(code)}&utm_source=referral&utm_medium=share&utm_campaign=each_one_reach_one`;
}

function claimReferral() {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref && ref !== getVisitorId() && !localStorage.getItem("apx_ref_claimed")) {
    localStorage.setItem("apx_ref_claimed", "1");
    api.post("/referral/claim", { ref, visitor_id: getVisitorId() }).catch(() => {});
  }
}

export async function getReferralCount() {
  try {
    const { data } = await api.get(`/referral/${encodeURIComponent(getVisitorId())}/count`);
    return data.count || 0;
  } catch { return 0; }
}
